import React from "react";
import { PASSIF_RARITIES, TRIGGER_LABELS, CONDITION_LABELS } from "../../data/passives";
import { Sparkles } from "lucide-react";

// Vue de sanctuaire réutilisable (même rendu qu'en solo).
// Props : rarity, options [{ uuid, icon, nom, description, rarity, trigger, condition }], onSelect(p), onSkip()
export const SanctuaryChoiceView = ({ rarity, options, onSelect, onSkip }) => {
  const cfg = PASSIF_RARITIES[rarity] || PASSIF_RARITIES.C || Object.values(PASSIF_RARITIES)[0];
  const isS = rarity === "S";

  return (
    <div className="relative w-full h-full bg-slate-900 bg-dots flex overflow-hidden">
      <div className="absolute top-10 left-10 w-72 h-72 bg-fuchsia-500/20 rounded-full blur-3xl" />
      <div className="absolute bottom-10 right-10 w-72 h-72 bg-purple-500/20 rounded-full blur-3xl" />

      <div className="relative z-10 w-full max-w-4xl m-auto p-6">
        <div className="text-center mb-6">
          <Sparkles className="w-16 h-16 mx-auto text-fuchsia-400 mb-2 animate-pulse-glow" />
          <h2 className="font-display text-3xl font-bold mb-2">Sanctuaire</h2>
          <div className="inline-block">
            <span data-testid="sanctuary-rarity" className={`${cfg.couleur} ${cfg.textColor} border-4 border-slate-950 rounded-2xl px-4 py-1 font-display font-bold uppercase cartoon-shadow-static ${isS ? "animate-prismatic" : ""}`}>
              {cfg.nom}
            </span>
          </div>
          <p className="text-slate-300 mt-3">Choisis un passif (cumulable à l'infini)</p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 mb-6">
          {options.map((p, i) => (
            <button
              key={p.uuid || i}
              data-testid={`sanctuary-option-${i}`}
              onClick={() => onSelect(p)}
              className="text-left bg-slate-800 border-4 border-slate-950 rounded-2xl p-5 cartoon-shadow-lg-static hover:-translate-y-2 transition-transform"
            >
              <div className="flex items-center gap-2 mb-3">
                <span className="text-3xl">{p.icon}</span>
                <span className={`${cfg.couleur} ${cfg.textColor} border-2 border-slate-950 rounded-lg px-2 py-0.5 text-xs font-bold uppercase`}>{p.rarity}</span>
              </div>
              <h3 className="font-display font-bold text-lg mb-1">{p.nom}</h3>
              <p className="text-sm text-slate-300 mb-2">{p.description}</p>
              <p className="text-xs uppercase tracking-wider text-fuchsia-400 font-bold">
                Déclenche : {TRIGGER_LABELS[p.trigger] || p.trigger}
                {p.condition ? ` · ${CONDITION_LABELS[p.condition] || p.condition}` : ""}
              </p>
            </button>
          ))}
        </div>

        {onSkip && (
          <div className="text-center">
            <button data-testid="skip-sanctuary-btn" onClick={onSkip}
              className="bg-slate-700 text-white border-4 border-slate-950 rounded-xl px-4 py-2 cartoon-shadow text-sm font-bold uppercase tracking-wider">
              Passer (aucun passif)
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
